




























import { Component, Vue, Watch } from 'vue-property-decorator'
import History from '@/components/upload/historyList.vue'
import ffButton from '@/components/public/Button.vue'
import { namespace} from 'vuex-class'
const appStore = namespace('app')
@Component({
  components: {
    History,
    ffButton
  }
})
export default class Upload extends Vue {
  uploadInfo: object = {
    showFileList: false,
    autoUpload: true,
    accept: '.png,.jpeg,.jpg,.gif'
  }
  fileList: object[] = []
  uploadList: object[] = []
  @appStore.State(state => state.isLogin) isLogin: boolean
  @appStore.State(state => state.uploading) uploading: boolean
  @appStore.Action('setUpload') setUpload: Function
  @Watch('isLogin')
  isLoginChange(val: boolean) {
    if (!val) {
      this.setUpload(false)
      this.fileList = [] // 赋值情空
      this.uploadList = [] // 赋值情空
    }
  }
  loginNotice (): void {
    if (!this.isLogin) {
      this['$notify'].error({
        title: 'Failed',
        message: `Please Sign in first!`,
        duration: 0,
        offset: 80
      })
    }
  }
  handleExceed (): void {
    const limit = this.uploadInfo['limit']
    this['$alert'](`Only upload ${limit} images at once`, 'Warn', {
      confirmButtonText: 'Confirm',
      callback: () => {
        return
      }
    })
  }
  beforeUpload (file: any) {
    const fileSize = file.size
    if (fileSize > 1024 * 1024 ) {
      this['$notify'].error({
        title: 'Failed',
        message: `[ ${file.name} ] size is greater than 1MB, please compress!`,
        duration: 0,
        offset: 80
      })
      return false
    } else {
      const nowTime = parseInt((new Date().getTime() / 1000).toString())
      this.fileList.unshift({
        file: file,
        name: file.name,
        size: file.size,
        progress: 0,
        status: 0,
        url: '',
        time: nowTime
      })
    }
    this.setUpload(true)
    this.$refs.history['updateUploading'](this.fileList)
  }
  handleContinue (): void {
    this.setUpload(false)
    this.fileList = [] // 赋值情空
    this.uploadList = [] // 赋值情空
  }
  changeUpload (file: any, fileList: any): void {
    this.uploadList = fileList
  }
  handleLeave (resolve: Function): void {
    this['$confirm'](`Are you sure to leave? Upload list will be cleared，You can go to the history to find the successful upload record`, 'Confirm', {
      distinguishCancelAndClose: true,
      confirmButtonText: 'Confirm',
      cancelButtonText: 'Cancel'
    }).then(() => {
      resolve()
    }).catch(() => {
      return
    })
  }
  toHistory (): void {
    this.handleLeave(() => {
      this.setUpload(false)
      this['$router'].push('/history-images').catch(() => { return })
    })
  }
  uploadFileInfo (uid: number): object {
    return this.fileList.filter((item: object) => item['file'].uid === uid)[0]
  }
  upload (data: any): void {
    const fileItem = data.file
    const formData = new FormData()
    const fileInfo = this.uploadFileInfo(fileItem.uid)
    formData.append('file', fileItem)
    fileInfo['status'] = 0
    this['$api'].post('/upload', formData, {
      header: { 'Content-Type': 'multipart/form-data' },
      onUploadProgress: (progressEvent: any) => {
        const complete = (progressEvent.loaded / progressEvent.total * 100 | 0)
        fileInfo['progress'] = complete
      }
    }).then((res: object) => {
        const data = res['data']
        fileInfo['status'] = data['status']
        fileInfo['url'] = data['url']
        if (data['upload_time']) {
          fileInfo['time'] = data['upload_time']
        }
        if (data['status'] === 2) {
          this['$notify'].error({
            title: 'Failed',
            message: `[ ${fileInfo['name']} ] upload failed!`,
            duration: 0,
            offset: 80
          })
        }
    }).catch(() => {
      fileInfo['status'] = 3
    })
  }
  tryUpload (uid: number) { // 最好不要一层一层传
    const data = this.uploadFileInfo(uid)
    this.upload(data)
  }
  mounted (): void {
    window.onbeforeunload =  (e: any) => {
      e = e || window.event
      if (this.uploading) {
        if (e) {
          e.returnValue = 'notice'
        }
        return 'notice'
      }
    }
  }
}
